import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';
import { Component } from 'vue-property-decorator';

import decision from './decision';
import jobs from './jobs';
import task from './task';
import analyze from './analyze';
import platform from './platform';
import screen from './screen';
import data from './data';
Vue.use(VueRouter);

const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: string): Promise<Route> {
  return originalPush.call(this, location).catch((err: any) => err);
};
const PLACEHOLDER = { template: "<div>PLACEHOLDER</div>" };

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/main.vue'),
    redirect: '/data',
    children: [decision, jobs, task, analyze, platform, data]
  },
  {
    path: '/screen',
    name: 'screen',
    component: () => import('../views/screen/screen.vue'),
    children: [screen]
  },
  {
    path: '/login',
    name: 'login',
    component: PLACEHOLDER,
    beforeEnter() {
      //debugger
      const fullPath = encodeURIComponent(window.location.href);
      //const fullPath = encodeURIComponent(router.currentRoute.fullPath)
      location.href = 'https://meta.kstartup.cn/datax/#/login?redirect=' + fullPath;
      // location.href = 'https://meta.kstartup.cn/datax/#/login'
    }
  }
];

const router = new VueRouter({
  routes
});

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title || 'SBMS-WEB';
  next();
});

export default router;
